import { createSelector } from "reselect";

export const getLanguageStore = (state) => state.language;

export const getLocale = createSelector(getLanguageStore, (language) => (language.locale ? language.locale.countryCode : null));
export const getMessages = createSelector(getLanguageStore, getLocale, (language, locale) => language.messages.get(locale));
